<section class="py-8 lg:py-12 3xl:py-16">
  <div class="px-[4%] sm:px-[9.3%]">
    <h2
      class="text-3xl text-center sm:text-4xl 3xl:text-5xl lg-leading-[40px] 3xl:leading-[57.6px] font-semibold 3xl:font-bold text-dark-gray2 mb-6 sm:mb-10 3xl:mb-13">
      Testimonials</h2>
    <div class="grid grid-cols-12 gap-8 sm:gap-12 lg:gap-16 2xl:gap-20 3xl:gap-[105px]">
      <div *ngFor="let testimonial of testimonials; let i = index" [ngClass]="{'sm:col-start-4': i === 2}"
        class="col-span-12 sm:col-span-6 lg:col-span-4 p-6 3xl:p-8 flex flex-col justify-between rounded-md 3xl:rounded-lg border border-light-gray1 bg-card-gray h-full hover:bg-white  duration-500 hover:shadow-lg">
        <p class="text-sm 2xl:text-base 3xl:text-xl font-light mb-20 sm:mb-16 ">
          {{testimonial.desc}} </p>
        <div>
          <hr class="border border-teal2 opacity-60 mb-4 3xl:mb-6">
          <div class="flex items-center gap-3 4xl:gap-4">
            <img height="40" width="40" loading="lazy" [src]="testimonial.imgUrl" class="w-10 h-auto 3xl:w-12 object-cover rounded-full" alt="profile-image">
            <div class="flex flex-col justify-between items-start">
              <h4 class="text-sm 3xl:text-base font-semibold">{{testimonial.name}}</h4>
              <p class="text-dark-gray2 text-sm 3xl:text-base">{{testimonial.designation}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>